<template>
  <div class="animated fade-in">
    <h1 class="display-4 font-weight-lighter">Invite Employees</h1>
    <employee-table></employee-table>
  </div>
</template>

<script>
import EmployeeTable from "../../components/employees/EmployeeTable";

export default {
  name: "EmployeeIndex",
  components: {EmployeeTable}
};
</script>
